<div class="tanker-wrapper">
  <h1 class="total-label">{{ totalVolume }} m³</h1>

  <div class="tank-body">
    <div *ngFor="let value of compartments" class="section">
      {{ value }}
    </div>
  </div>

  <div class="frame-structure">
    <div class="hitch-hook"></div>

    <div class="chassis-bar"></div>

    <div class="wheels-and-guards-container">
      <div class="wheel-assembly">
        <div class="guard"></div>
        <div class="wheel"></div>
      </div>

      <div class="wheel-assembly">
        <div class="guard"></div>
        <div class="wheel"></div>
      </div>
    </div>
  </div>
</div>
